<div class="item-container pt-0">
    <div class="edit-icons" (click)="onCancel()"> 
        <i class="material-icons">close</i>
    </div>
    <div class="content"  *ngIf="(dialogData.api_type=='delete_content')">
        <div class="delete-img mt-4  text-center">
            <img src="assets/images/gifs/112002-delete-files.gif" class="img-fluid" alt="">
        </div>
        <h5 class="text-center item-txt mt-3">{{"DELETTE.CONFIRMATION" | translate}}</h5>
        <div class="item-small mt-3 text-center">{{"DELETTE.CONTENT" | translate}}</div>
    </div>
    <div class="content" *ngIf="dialogData.api_type=='block_user'">
        <div class="block-box mt-4  text-center" >
            <img  *ngIf="dialogData.block_type=='1'" src="assets/images/apps/user_block_ic.svg" class="img-fluid" alt="">
            <img  *ngIf="dialogData.block_type=='0'" src="assets/images/apps/user_unblock_ic.svg" class="img-fluid" alt="">
        </div>
        <h5 class="text-center item-txt mt-3">Are you sure you want to {{ dialogData.block_type=='1' ? 'Block' : 'Unblock' }} this user?</h5>
      
        <div class="item-small mt-3 text-center">This can be reverted anytime you want.</div>
    </div>
    <div class="content" *ngIf="dialogData.api_type=='pub_content'">
        <div class="block-box new-bg mt-4  text-center" >
            <img  *ngIf="dialogData.pub==1" src="assets/images/package/unpublish_ic.svg" class="img-fluid" alt="">
            <img  *ngIf="dialogData.pub==0" src="assets/images/package/publish_ic.svg" class="img-fluid" alt="">
        </div>
        <h5 class="text-center item-txt mt-3">Are you sure you want to {{ dialogData.pub==1 ? 'Unpublish' : 'Publish' }} this Package?</h5>
      
        <div class="item-small mt-3 text-center">This can be reverted anytime you want.</div>
    </div>
    <div class="btn-container d-flex mt-4">
        <button color="" class="auth-form-btn outline-btn new-outline d-flex align-items-center justify-content-center"
            (click)="onCancel()">{{"BUTTON.CANCEL" | translate}}</button>
        <button mat-raised-button color="warn" class="auth-form-btn  danger-btn ms-3" type="submit" *ngIf="dialogData.api_type=='delete_content'"
            (click)="onDeleteClick()">{{"BUTTON.DELETE" | translate}}</button>
        <button mat-raised-button color="warn" class="auth-form-btn  danger-btn ms-3"
        [ngClass]="{'danger-btn': dialogData.block_type=='1' , 'success-btn' : dialogData.block_type=='0' }"
         type="submit" *ngIf="dialogData.api_type=='block_user'"
            (click)="onDeleteClick()"> {{ dialogData.block_type=='1' ? 'Block' : 'Unblock' }}</button>
            <button mat-raised-button color="warn" class="auth-form-btn  danger-btn ms-3"
            [ngClass]="{'danger-btn': dialogData.pub==1 , 'success-btn' : dialogData.pub==0 }"
             type="submit" *ngIf="dialogData.api_type=='pub_content'"
                (click)="onPubUnpubPackage()"> {{ dialogData.pub==1 ? 'Unpublish' : 'Publish' }}</button>    
    </div>
</div>
<app-loading-spinner></app-loading-spinner>